import React from "react";

interface Props {
  value: string;
  name: string;
  label: string;
  error?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Field = ({ value, name, label, error, onChange }: Props) => {
  return (
    <div className="form__group cols-md--4 cols-sm--6">
      <p className="calc__label">{name}</p>
      <div className="form__control-container">
        <input
          type="number"
          className="form__control"
          placeholder={label}
          value={value || ""}
          onChange={onChange}
        />
        <label className="form__label">{label}</label>
        {error && <div className="form__error">{error}</div>}
      </div>
    </div>
  );
};

export default Field;
